import PropTypes from 'prop-types';
import React from 'react';
import { MapPin } from 'lucide-react';

import Thumbnail from 'components/Thumbnails/Thumbnail';

import styles from './DashboardHero.module.scss';

/**
 * Hero section for the Client ATS Dashboard. Shows a welcome message,
 * user avatar, company and location on a blue gradient background.
 */
const DashboardHero = ({ user }) => {
  const displayName =
    user?.displayname &&
    user.displayname.trim() &&
    user.displayname.toLowerCase() !== 'client'
      ? user.displayname.trim()
      : '';
  const company = user?.organisation || false;
  const locationText =
    user?.location?.text &&
    user.location.text.trim() &&
    user.location.text.toLowerCase() !== 'private'
      ? user.location.text.trim()
      : '';

  const welcomeText =
    company || !displayName ? 'Welcome back!' : `Welcome back, ${displayName}!`;

  return (
    <section className={`${styles.hero}`} aria-label="Welcome">
      <div className={styles.content}>
        <div className={styles.avatarWrapper}>
          <Thumbnail
            thumbnails={user.avatars}
            className={styles.avatar}
            circle
          />
        </div>
        <div className={styles.textBlock}>
          <h2 className={styles.welcomeText}>{welcomeText}</h2>
          <div className={styles.metaLine}>
            {company && displayName && (
              <span className={styles.company}>{displayName}</span>
            )}
            {company && displayName && locationText && (
              <span className={styles.separator}>•</span>
            )}
            {locationText && (
              <span className={styles.location}>
                <MapPin
                  width={14}
                  height={14}
                  className={styles.locationIcon}
                  aria-hidden="true"
                />
                {locationText}
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

DashboardHero.propTypes = {
  user: PropTypes.object,
};

export default DashboardHero;
